export function segmentTitle(fileName) {
  if (!fileName) return '';
  const dot = fileName.lastIndexOf('.');
  return dot > 0 ? fileName.slice(0, dot) : fileName;
}

export function renderDescription(template, { title, index, series }) {
  const normalized = (template || '').trim();
  if (!normalized) return '';
  return normalized
    .replace(/\{title\}/g, title || '')
    .replace(/\{index\}/g, String(index != null ? index : ''))
    .replace(/\{series\}/g, series || '');
}

export function buildSegmentCopyText(clip, meta) {
  const title = segmentTitle(clip.fileName);
  const description = renderDescription(meta.descriptionTemplate, {
    title,
    index: clip.index,
    series: meta.seriesTitle,
  });
  const lines = [
    `标题：${title}`,
  ];
  if (meta.hashtags) {
    lines.push(`话题：${meta.hashtags}`);
  }
  if (description) {
    lines.push(`简介：${description}`);
  }
  return lines.join('\n');
}

export function buildBatchMarkdown(clips, meta) {
  const parts = ['# 批量发布文案', ''];
  if (meta.seriesTitle) {
    parts.push(`系列：${meta.seriesTitle}`, '');
  }
  if (meta.hashtags) {
    parts.push(`话题：${meta.hashtags}`, '');
  }
  clips.forEach((clip) => {
    const title = segmentTitle(clip.fileName);
    const description = renderDescription(meta.descriptionTemplate, {
      title,
      index: clip.index,
      series: meta.seriesTitle,
    });
    parts.push(`## ${clip.index}. ${title}`, '');
    parts.push(`标题：${title}`, '');
    if (meta.hashtags) {
      parts.push(`话题：${meta.hashtags}`, '');
    }
    parts.push(`简介：${description || ''}`, '');
    parts.push('---', '');
  });
  return `${parts.join('\n').trim()}\n`;
}

export async function copyText(text) {
  if (!text) {
    throw new Error('没有可复制的内容');
  }
  if (navigator.clipboard && navigator.clipboard.writeText) {
    await navigator.clipboard.writeText(text);
    return;
  }
  const textarea = document.createElement('textarea');
  textarea.value = text;
  textarea.setAttribute('readonly', '');
  textarea.style.position = 'absolute';
  textarea.style.left = '-9999px';
  document.body.appendChild(textarea);
  textarea.select();
  const ok = document.execCommand('copy');
  document.body.removeChild(textarea);
  if (!ok) {
    throw new Error('复制失败，请手动复制');
  }
}
